<template>
  <WatchEmailPT />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
